import { render, staticRenderFns } from "./app-rating.vue?vue&type=template&id=a524a560&scoped=true&"
import script from "./app-rating.vue?vue&type=script&lang=js&"
export * from "./app-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a524a560",
  null
  
)

export default component.exports